"use client";

import { StudioAltField } from "@/app/studio/pages/[slug]/StudioAltField";

export function studioAltField(label = "Alt text (required)") {
  return {
    type: "custom" as const,
    label,
    render: ({
      value,
      onChange,
    }: {
      value: string;
      onChange: (value: string) => void;
    }) => (
      <StudioAltField
        value={typeof value === "string" ? value : ""}
        onChange={onChange}
      />
    ),
  };
}
